import { closeResponseModal, responseModalContent } from './responseModal';
import { toggleLoader } from './loader';
import { closeFormModal, toggleButton } from './formModal';

const SERVICE_KEY = import.meta.env.VITE_EMAILJS_SERVICE_KEY;
const TEMPLATE_KEY = import.meta.env.VITE_EMAILJS_TEMPLATE_KEY;

export const sendEmail = () => {
  let params = {
    from_name: document.getElementById('fromName').value.trim(),
    email: document.getElementById('email').value.trim(),
    message: document.getElementById('message').value.trim(),
  };

  const closeFirstModal = () => {
    toggleLoader();
    toggleButton();
    closeFormModal();
  };

  emailjs
    .send(SERVICE_KEY, TEMPLATE_KEY, params)
    .then(res => {
      closeFirstModal();
      responseModalContent(res.status);

      setTimeout(() => {
        closeResponseModal();
      }, 2000);
    })
    .catch(error => {
      closeFirstModal();
      responseModalContent(error.status);
    });
};
